<template>
<div class="container-base"
     v-once>
  <div class="pages page-static">
    <div class="page-static-inner">
      <h2>個人情報保護方針</h2>
      <p>株式会社Yagish（以下「当社」といいます。）は、個人情報保護の重要性を強く認識し、法令その他規範を遵守し、お客様の大切な個人情報の取扱いには細心の注意を払います。そのため、当社は、当社がお客様に関する情報をどのように取得、利用、開示、移転及び保存するのかについて規定する個人情報保護方針を定めます。</p>
      <h2>1.個人情報の収集と利用</h2>
      <p>当社は、業務上、個人情報を収集する場合、利用目的を明確にした上でこれを行います。また、個人情報の利用に際しては、その利用目的の範囲内に限定し、適切な取扱いをいたします。</p>
      <ol>
        <li>当社が取扱う商品・サービスの提供・管理・案内のため</li>
        <li>当社が取扱う商品・サービスの提供に関する通知・連絡のため</li>
        <li>当社および提携先企業が取扱う商品・サービス等、各種イベント、キャンペーンの案内・運営・管理および各種情報の提供のため＊上記の目的で使用させて頂きますが、ご案内が不要なお客様は、当社にお申し出いただければ電子メール・DMなどの送信発送を中止いたします。</li>
      </ol>
      <h2>2.第三者への提供・委託について</h2>
      <p>当社は、収集した個人情報を、事前の承認なく、いかなる第三者にも開示・提供することはございません。ただし、以下の場合を除きます。</p>
      <ol>
        <li>法令に基づく場合</li>
        <li>人の生命・身体・財産の保護のために必要がある場合で、お客様の同意を得ることが困難である場合</li>
        <li>公衆衛生の向上または児童の健全な育成の推進のために必要がある場合で、お客様の同意を得ることが困難である場合</li>
        <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合で、お客様の同意を得ることにより当該事務の遂行に支障を及ぼす恐れがある場合</li>
        <li>収集・利用目的の達成に必要な範囲で、個人情報の取扱いを委託する場合</li>
        <li>合併その他の事由による事業の承継に伴い、個人情報を提供する場合また、業務委託先に個人情報の取扱いを委託する場合は、機密保持契約等により当該委託先に個人情報保護を義務づけるとともに、当該委託先が適切に個人情報を取扱うよう監督します。</li>
      </ol>
      <h2>3.個人の権利尊重</h2>
      <p>当社は、個人情報に関する情報主体の権利を尊重し、情報主体本人から自己の個人情報の開示・訂正・利用停止を求められたときは、これに対応します。</p>
      <h2>4.安全性・正確性の確保</h2>
      <p>当社は、個人情報の安全性と正確性を確保するため、不正なアクセス・紛失・破壊・改ざんおよび漏洩等を防止するための情報セキュリティ対策を実施します。</p>
      <h2>5.法令・規範の遵守</h2>
      <p>当社は、個人情報の取扱いに関し、「個人情報の保護に関する法律」および関連する法令ならびにその他の規範を遵守します。</p>
      <h2>6.社内への周知・徹底</h2>
      <p>お客様の個人情報の安全性を保持するため、当社は従業員にプライバシー及び安全性のガイドラインを伝達し、社内でのプライバシー保護対策を徹底しています。</p>
      <p class="text-left">個人情報保護に関するお問合せ窓口<br>
      〒150-0001<br>
      東京都渋谷区神宮前5-20-1モデリアブリュット表参道008<br>
      株式会社Yagish
      </p>
      <div class="back-button">
        <router-link to="/">トップに戻る</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
